export default __webpack_public_path__ + "static/media/Stacy.acb7bb44.png";